import React, { useState, useEffect } from 'react';
import api from '../services/api';

const UserRoleAssignment = () => {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedRole, setSelectedRole] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  useEffect(() => {
    loadUsers();
    loadRoles();
  }, []);

  const loadUsers = async () => {
    try {
      const usersData = await api.users.getAll();
      setUsers(usersData);
    } catch (error) {
      console.error('Error loading users:', error);
    }
  };

  const loadRoles = async () => {
    try {
      const rolesData = await api.roles.getAll();
      setRoles(rolesData);
    } catch (error) {
      console.error('Error loading roles:', error);
      setRoles([]);
    }
  };

  const handleUserSelect = (user) => {
    setSelectedUser(user);
    setSelectedRole(user.role_id || '');
  };

  const handleAssignRole = async () => {
    if (!selectedUser || !selectedRole) return;
    
    try {
      setLoading(true);
      await api.users.assignRole(selectedUser.id, { role_id: selectedRole });
      
      // Update local user data
      setUsers(prev => prev.map(user => 
        user.id === selectedUser.id 
          ? { ...user, role_id: selectedRole }
          : user
      ));
      
      setMessage({ text: 'Role assigned successfully!', type: 'success' });
    } catch (error) {
      setMessage({ text: 'Error assigning role', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <h5 className="mb-0">User Role Assignment</h5>
      </div>
      <div className="card-body">
        {message.text && (
          <div className={`alert alert-${message.type === 'success' ? 'success' : message.type === 'warning' ? 'warning' : 'danger'}`}>
            {message.text}
          </div>
        )}

        <div className="row mb-4">
          <div className="col-md-4">
            <label className="form-label">Select User</label>
            <select 
              className="form-control"
              onChange={(e) => {
                const user = users.find(u => u.id === parseInt(e.target.value));
                if (user) handleUserSelect(user);
              }}
              value={selectedUser?.id || ''}
            >
              <option value="">Choose a user...</option>
              {users.map(user => (
                <option key={user.id} value={user.id}>
                  {user.username} - Current Role: {roles.find(r => r.id === user.role_id)?.name || 'None'}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-4">
            <label className="form-label">Assign Role
              
            </label>
            <select 
              className="form-control"
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
            >
              <option value="">Choose a role...</option>
              {roles.map(role => (
                <option key={role.id} value={role.id}>
                  {role.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-4 d-flex align-items-end">
            <button 
              className="btn btn-primary"
              onClick={handleAssignRole}
                    
              disabled={!selectedUser || !selectedRole || loading}
            >
              {/* {loading ? 'Assigning...' : 'Assign Role'} */}
              <i className="bi bi-check-circle"></i>
            </button>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Username</th>
                <th>Email</th>
                <th>Current Role</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map(user => (
                <tr key={user.id}>
                  <td>{user.username}</td>
                  <td>{user.email}</td>
                  <td>
                <span className={`badge ${user.role_id ? 'bg-primary' : 'bg-danger'}`}>
                      {roles.find(r => r.id === user.role_id)?.name || 'No Role'}
                    </span>
                  </td>
                  <td>
                    <button 
                      title='Edit'
                      className="btn btn-sm btn-primary"
                      onClick={() => handleUserSelect(user)}style={{ fontSize: '13px', padding: '4px 10px' }}
                    >
                      <i className="bi bi-pencil-square"></i> 
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default UserRoleAssignment;